import styled from 'styled-components';
import { Title } from '@lux/title';
import { Button } from '@lux/buttons';
import { FunctionColor } from '@lux/tokens';
import { Spacer } from '@lux/tokens';

export const CrossCampaignContainer = styled.div`
    margin: ${Spacer.S} 0;
    padding-block: ${Spacer.S};
    padding-block: ${Spacer.S};
    background-color: ${({ theme }) => theme.functionColor.function0};
`;

export const StyledTitle = styled(Title)`
    margin: 0 0 ${Spacer.S} 16px;
    line-height: 1;
`;

export const Space12 = styled.div`
    width: ${Spacer.S};
`;

export const StyledButton = styled(Button)<{ selected: boolean }>`
    border: 2px solid;
    border-color: ${({ selected }) =>
        selected ? FunctionColor.function100 : FunctionColor.function20} !important;
    color: ${FunctionColor.function100} !important;
    font-size: 1.6rem;
    border-radius: 8px;
    padding: ${Spacer.S};
    display: block;
    margin-inline-end: ${Spacer.S};
    overflow: unset;

    span {
        font-weight: ${({ selected }) => (selected ? 'bold' : 'normal')};
        width: max-content;
        display: block;
    }

    :focus {
        outline: none;
    }
`;

export const Container = styled.div`
    display: flex;
    overflow-x: scroll;
    padding-inline-start: ${Spacer.S};

    ::-webkit-scrollbar {
        width: 0;
        height: 0;
    }
`;

export const Wrapper = styled.div`
    display: block;
    text-align: center;
    margin-right: 8px;

    :first-child {
        margin-left: 16px;
    }
`;

export const StyledImageWrapper = styled.div`
    margin-bottom: 4px;
`;

export const StyledImage = styled.img`
    width: 70px;
    height: 70px;
    border-radius: 50%;
`;
